import { buildProps as o } from "./index601.js";
import { componentSizes as p } from "./index684.js";
const t = o({
  size: {
    type: String,
    values: p
  }
});
export {
  t as paginationJumperProps
};
